import { Box } from '@mui/material';
import Chart from 'react-apexcharts';

import WidgetWrapper from '../WidgetWrapper';
import { cardChartLabel } from '../style';
import { getRuntimeChartOptions, CHART_LABEL } from '../../config';
import { ChartData } from '../../types';

type Props = {
  title: string;
  values: ChartData[] | null;
  isEditMode?: boolean;
  widgetId?: string;
  toggleAddOrRemoveHandler?: () => void;
  testId?: string;
};

export const RunTimeChart = ({
  title,
  values,
  isEditMode,
  widgetId,
  toggleAddOrRemoveHandler,
  testId,
}: Props) => {
  const fullTitle = `${title} Runtime`;
  const options = values
    ? getRuntimeChartOptions(
        values.map((x) => x.label),
        values.map((x) => x.value)
      )
    : getRuntimeChartOptions([]);
  const series = values ? [{ name: 'Runtime', data: values.map((x) => x.value) }] : [];
  return (
    <WidgetWrapper
      title={fullTitle}
      isEditMode={isEditMode}
      widgetId={widgetId!}
      toggleAddOrRemoveHandler={toggleAddOrRemoveHandler}
      testId={testId}
      isDataReady={values !== null}
      isTrendWidget={true}
      options={options}
      series={series}
      typeChart="bar"
    >
      <Chart options={options} series={series} type="bar" width="100%" height="90%" />
      <Box display="span" sx={cardChartLabel}>
        {CHART_LABEL}
      </Box>
    </WidgetWrapper>
  );
};

export default RunTimeChart;
